import { MessageInstance } from 'antd/es/message/interface'

export function displayMessage(
  message: string | null,
  type: 'error' | 'success',
  messageApi: MessageInstance
) {
  messageApi.open({
    type: type,
    key: 'anidra_message',
    content: message,
    duration: 3,
    style: {
      marginTop: '50px',
      fontWeight: 'medium',
      letterSpacing: '2px',
      border: '3px outline black',
      color: 'black',
    },
  })
}
